module.exports = __webpack_public_path__ + "static/hans-rituals-a4909a6c27d558338c10b9da6dc3e850.jpg";